import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { t as transformTagNameByElementReference } from './tag-name.js';
import { c as cosmosTokens } from './cosmos-tokens.js';

const styles = "/* Easing and Timing */\n/* Grid */\n/* Component */\n/* 1px */\n/* Breakpoints */\n/* Structure */\n/* Modal */\n/* Drawer */\n/* Colors */\n:host {\n  display: inline-block;\n}";

const HcTooltip$1 = /*@__PURE__*/ proxyCustomElement(class HcTooltip extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.position = 'top';
    this.role = 'tooltip';
    this.text = undefined;
  }
  connectedCallback() {
    this.isRTL = Boolean(this.el.closest('[dir=rtl]'));
    this.showTooltip = this.showTooltip.bind(this);
  }
  showTooltip() {
    this.tooltip.show(this.el.getBoundingClientRect(), this.isRTL);
  }
  disconnectedCallback() {
    var _a;
    (_a = this.tooltip) === null || _a === void 0 ? void 0 : _a.hide();
  }
  createTooltip() {
    const hcTooltipConcreteTag = transformTagNameByElementReference('hc-tooltip-concrete', 'hc-tooltip', this.el);
    this.tooltip = document.createElement(hcTooltipConcreteTag);
    this.tooltip.position = this.position;
    this.tooltip.role = this.role;
    this.tooltip.text = this.text;
    this.tooltip.addEventListener('hcTooltipConcreteLoaded', this.showTooltip);
    document.body.append(this.tooltip);
  }
  onMouseLeave() {
    this.tooltip.hide();
  }
  render() {
    return (h("div", { class: "hc-tooltip" }, h("slot", null), h("style", null, cosmosTokens.getStyle()), h("style", { type: "text/css" }, styles.toString())));
  }
  get el() { return this; }
}, [1, "hc-tooltip", {
    "position": [1],
    "role": [513],
    "text": [1]
  }, [[1, "mouseenter", "createTooltip"], [1, "mouseleave", "onMouseLeave"]]]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["hc-tooltip"];
  components.forEach(tagName => { switch (tagName) {
    case "hc-tooltip":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, HcTooltip$1);
      }
      break;
  } });
}

const HcTooltip = HcTooltip$1;
const defineCustomElement = defineCustomElement$1;

export { HcTooltip, defineCustomElement };

//# sourceMappingURL=hc-tooltip.js.map